<template>
	<div class="card">
		<div class="card-header">
			<h2 align="center" style="font-weight: 700" class="text-primary">
				EXPENDITURE DETAILS <br />
				<span v-if="form" class="badge bg-danger" style="font-size: 12px"
					>By {{ form[0].user }}</span
				>
			</h2>
		</div>
		<div v-if="form" class="card-block">
			<div class="card-body" style="background: #fff">
				<legend>Report Details:</legend>
				<div class="row">
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="report_from" class="col-sm-4 col-form-label"
								>Name of Political Party:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].party"
									name="report_from"
									id="report_from"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="report_to" class="col-sm-4 col-form-label"
								>State:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].state"
									name="report_to"
									id="report_to"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="report_to" class="col-sm-4 col-form-label"
								>L.G.A:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].lga"
									name="report_to"
									id="report_to"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="report_to" class="col-sm-4 col-form-label"
								>Senatorial Zone:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].sd"
									name="report_to"
									id="report_to"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="report_to" class="col-sm-4 col-form-label"
								>Federal Constituency:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].constituency"
									name="report_to"
									id="report_to"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="report_to" class="col-sm-4 col-form-label"
								>State Constituency:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].state_constituency"
									name="report_to"
									id="report_to"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="report_to" class="col-sm-4 col-form-label"
								>Type of Election:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].position"
									name="report_to"
									id="report_to"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>

					<div class="col-md-6">
						<div class="row mb-3">
							<label for="approval_document" class="col-sm-4 col-form-label"
								>Approval Document:</label
							>
							<div class="col-sm-8">
								<a
									:href="form[0].approval_document"
									target="_blank"
									class="btn btn-link form-control"
									>View Document</a
								>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="approved_by" class="col-sm-4 col-form-label"
								>Approved By:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].approved_by"
									name="approved_by"
									id="approved_by"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>

					<div class="col-md-6">
						<div class="row mb-3">
							<label for="submitted_by" class="col-sm-4 col-form-label"
								>Report Submitted By:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].user"
									name="submitted_by"
									id="submitted_by"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="audited_by" class="col-sm-4 col-form-label"
								>Audited By:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].audited_by"
									name="audited_by"
									id="audited_by"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="accountant_name" class="col-sm-4 col-form-label"
								>Accountant Name:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].accountant_name"
									name="accountant_name"
									id="accountant_name"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="created_at" class="col-sm-4 col-form-label"
								>Report Date:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].date_reported"
									name="created_at"
									id="created_at"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="row mb-3">
							<label for="created_at" class="col-sm-4 col-form-label"
								>Submitted Date:</label
							>
							<div class="col-sm-8">
								<input
									:value="form[0].date_created"
									name="created_at"
									id="created_at"
									type="text"
									class="form-control"
									disabled
								/>
							</div>
						</div>
					</div>
				</div>
				<div v-if="$route.query.edt" align="right">
					<a href="#" class="btn btn-secondary">Edit</a>
				</div>
			</div>
			<div class="dt-responsive table-responsive">
				<table id="dt-live-dom" class="table table-bordered nowrap">
					<thead
						style="border-top: 2px solid green; border-bottom: 2px solid green"
					>
						<tr>
							<th>S/NO</th>
							<th>EXPENDITURE HEAD</th>
							<th>NUMBER/QUANTITY</th>
							<th>UNIT COST</th>
							<th>TOTAL COST</th>
							<th>REMARKS</th>
							<th v-if="$route.query.edt">ACTION</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(expenditure, index) in form"
							:key="'ex' + expenditure.id"
						>
							<td>{{ index + 1 }}.</td>
							<td>
								{{ expenditure.expenditure }}
							</td>
							<td>
								{{ expenditure.quantity }}
							</td>
							<td>
								{{ expenditure.unit_cost }}
							</td>
							<td>
								{{ expenditure.total_cost }}
							</td>
							<td>
								{{ expenditure.remarks }}
							</td>
							<td v-if="$route.query.edt">
								<a
									@click.prevent="setReport(expenditure)"
									href="#!"
									class="btn btn-info btn-sm"
									><i class="feather icon-edit"></i>&nbsp;Edit
								</a>
							</td>
						</tr>
					</tbody>
					<tfoot style="border-bottom: 2px solid green">
						<tr>
							<th>S/NO</th>
							<th>EXPENDITURE HEAD</th>
							<th>NUMBER/QUANTITY</th>
							<th>UNIT COST</th>
							<th>TOTAL COST</th>
							<th>REMARKS</th>
							<th v-if="$route.query.edt">ACTION</th>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
		<div align="center" style="margin-bottom: 1rem">
			<a
				@click.prevent="closeTab()"
				class="btn btn-secondary"
				style="border-radius: 6px"
				>Go Back</a
			>
		</div>

		<ExpenditureEditModal :report="report" />
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/utils/event_bus.js";
import ExpenditureEditModal from "./ExpenditureEditModal.vue";

export default {
	name: "ExpenditureView",
	components: {
		ExpenditureEditModal,
	},
	data() {
		return {
			report: null,
		};
	},
	computed: {
		...mapGetters({
			form: "form_ec16e/singleForm",
		}),
	},
	methods: {
		...mapActions({
			getFormById: "form_ec16e/getFormById",
		}),

		setReport(report) {
			this.report = report;
			return EventBus.$emit("toggle-modal", "show");
		},
		closeTab() {
			return this.$router.back();
			// if (this.$route.query.edt) {
			// 	return this.$router.back();
			// }

			// if (confirm("Are you sure you want to close this window?")) {
			// 	window.close();
			// }
		},
	},
	mounted() {
		if (this.form && this.form.batch_id == this.$route.params.batch_id) {
			return;
		}

		this.getFormById({ batch_id: this.$route.params.batch_id });
	},
};
</script>
<style scoped>
legend {
	background-color: #29623c;
	color: white;
	padding: 5px 10px;
}
</style>
